export const credUsername = 'rest-client'
export const credPassword = '$tL{x<M5u#pK~}56Lx5L41mRd][`{3'

export const initial_state = {
    app_loaded: false,

    language: null,

    is_auth: false,
    user: null,
    user_details: null,
    user_subscription: null,
    user_subscription_constraints: null,
    user_subscriptions: null,
    products: null,
    merchantCode: null,
    user_notifications: null,
    user_trial_count: null,

    project_features: {
        // for update use USER__SET_SUBSCRIPTION action
        list_of_available: null,
        // for update use PRODUCTS__SET action
        list_of_descriptions: null,
    },

    token: null,

    credentials: {
        type: 'Basic',
        username: credUsername,
        password: credPassword,
    },

    _service: {
        nav_menu_width: 0,
        styles: {
            window_width: 0,
            window_height: 0,
            header_width: 0,
            header_height: 0,
        },
    },

    assetManager: {
        managerTab: null,
        library: {
            libraryTab: null,
            search: '',
            selectedImageId: null,
            isLoadImages: false,
            isLoadError: false,
            offset: 0,
            images: { content: [], pageable: { pageSize: 20, pageNumber: 0 }, totalPages: 0, mock: true },
        },
        projectId: '',
        uploadMedia: {},
    },
    editor: {
        mounted: false,
        enablePopups: false,
        screens: null,
        activeScreenId: null,
        activePopupId: null,
        showPopup: false,
        projectTypeData: {},
        projectType: null,
    },
}
